import LayoutPage from "../../Components/LayoutPage"
import NavLayer2 from "../../Components/NavLayer2/NavLayer2"
import Container from "./Components/Container"

const RulesChallenges = [
  {question: "فرآیند ارزیابی و اهداف زمانی",
    answer: (
      <div>
        <p>مسیر رسیدن به حساب واقعی در کوژیتو شامل دو مرحله «ارزیابی» و «تثبیت» است. مهلت تکمیل مرحله اول (چالش) ۳۰ روز تقویمی و مرحله دوم (تثبیت) ۶۰ روز تقویمی می‌باشد.</p>
        <p>هدف سود (Target) برای عبور موفقیت‌آمیز از مرحله چالش ۱۰٪ و برای مرحله تثبیت نیز ۶٪ تعیین شده است. لازم به ذکر است که در مرحله نهایی (حساب فاندد)، هیچ تارگت سودی وجود ندارد و معامله‌گر مالک سود کسب شده خواهد بود.</p>
      </div>
    ),
  },
  {question: "زمان مجاز استفاده از چالش",
    answer: (
      <div>
        <p>معامله‌گر ۳۰ روز تقویمی از زمان خرید چالش در مرحله ارزیابی و ۶۰ روز تقویمی در مرحله تثبیت فرصت دارد تا به اهداف تعیین شده دست‌یابد. پس از آن صرفا برای حساب‌های مرحله اول (ارزیابی) یک شانس تلاش مجدد (ریست) رایگان وجود دارد و سپس حساب منقضی خواهد شد.</p>
      </div>
    ),
  },
  {question: "قابلیت تلاش مجدد (Reset)",
    answer: (
      <div>
        <p>ما برای معامله‌گرانی که اصول مدیریت ریسک را رعایت کرده‌اند اما موفق به کسب تارگت سود نشده‌اند، شانس مجدد قائلیم. اگر در پایان مهلت ۳۰ روزه‌ی مرحله اول (ارزیابی)، نتوانستید به سود ۱۰٪ برسید، می‌توانید درخواست «ریست» دهید تا یک حساب جدید با همان بالانس و مهلت اولیه به شما اختصاص یابد.</p>
        <p className="font-medium">شرایط لازم برای ریست:</p>
        <ul className="list-disc list-inside">
          <li>مهلت چالش به پایان رسیده باشد.</li>
          <li>حساب در سود باشد (حتی ۱ دلار مثبت).</li>
          <li>هیچ‌گونه نقض قانونی (دراودون روزانه یا کل) رخ نداده باشد.</li>
          <li>حداقل ۵ روز معاملاتی تکمیل شده باشد.</li>
        </ul>
        <p className="font-medium">نکته: این قابلیت تنها یک‌بار برای هر چالش قابل استفاده است و درخواست آن باید از طریق پنل کاربری در بخش حساب‌ها و چالش‌ها (گزینه‌ی فعال کردن حساب) ثبت شود.</p>
      </div>
    ),
  },
  {question: "حداقل روزهای معاملاتی (Minimum Trading Days)",
    answer: (
      <div>
        <p>برای عبور از مراحل ارزیابی، صرفا رسیدن به سود کافی نیست و باید فعالیت معاملاتی داشته باشید.</p>
        <ul className="list-disc list-inside">
          <li>مرحله اول (ارزیابی): حداقل ۵ روز معاملاتی فعال.</li>
          <li>مرحله دوم (تثبیت): حداقل ۵ روز معاملاتی فعال.</li>
        </ul>
        <p>پس از تکمیل این روزها و رسیدن به تارگت سود، می‌توانید وارد مرحله بعدی شوید.</p>
      </div>
    ),
  },
]

export default function NotificationAll() {
  return (
    <LayoutPage activeIndex={15} navItems={["قوانین"]} childrenClassName="flex-1 min-h-0 flex flex-col gap-5">
      <NavLayer2 texts={["عمومی" , "چالش‌ها", "برداشت", "دعوت از دوستان"]} hrefs={["/rule/general" , "/rule/challenge", "/rule/withdraw", "/rule/invite"]} activeIndex={1}/>
      <div className="w-full h-fit flex flex-col items-center gap-5 min-h-0 overflow-y-auto">
        <Container items={RulesChallenges}/>
      </div>
    </LayoutPage>
  )
}